/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-05-05
 */

 import Api from 'src/util/api';
 import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
 import EnumItem from 'src/enums/enumItem';
 
 export declare namespace ElseSnConfigDOI {
     export interface RowDataI {
         id: number
         sn: string
         sn_status: number
         user_name: string
         user_phone: string
         register_time: string
         lower_computer_type:number
     }
 
     export interface QueryRowDataParamsI extends PageDo {
         sn?: string;
         user_name?: string;
         lower_computer_type?:number;
         lower_computer_permission?:number;
     }
 
     export interface OperateParamsI {
         id?: Integer
         user_name: string
         user_phone: string
         lower_computer_permission?:number;
     }
 
     export interface RowDataIs {
         id?:Integer
         sn:string
         file_name:string
         time:string
     }
 }
 
 export default class ElseSnConfigApi {
     /**
      * 不同类型下位机查询sn号信息
      */
     static async searchList(params: ElseSnConfigDOI.QueryRowDataParamsI): Promise<ResultPageDo<ElseSnConfigDOI.RowDataI[]>> {
        return Api.post('/monitor/slave_type/query/sn/info', {
             sn:"",
             user_name:"",
             lower_computer_type:-2,
             ...params
        });
     }
 
     /**
      * 不同类型下位机编辑sn号信息
      * @param data
      */
     static async update(data: ElseSnConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/monitor/slave_type/edit/sn/info', data);
     }
     
     /**
      * 不同类型下位机删除sn号信息
      * @param sn_id 
      */
     static async delete(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/slave_type/delete/sn/info', {id});
     }
 
     /**
      * 不同类型下位机启用sn
      * @param id
      */
     static async onSn(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/slave_type/on/sn/info', {id});
     }
 
 
     /**
      * 不同类型下位机禁用sn
      * @param id
      */
      static async offSn(id: number ): Promise<Result<any>> {
        return Api.post('/monitor/slave_type/off/sn/info', {id});
     }
 }
 